type PlanzoneSettings = {
  areWeeklyCalendarLockedForNonAdmin: boolean;
  areUsersNotifiedAfterAccountCreation: boolean;
  areProjectStatsHiddenInProjectListing: boolean;
  areTimeSheetsAutoIntegrated: boolean;
  canWorkersCreateTask: boolean;
  canWorkersEditTask: boolean;
  canWorkersRemoveTask: boolean;

  canWorkersCreateList: boolean;
  canWorkersEditList: boolean;
  canWorkersRemoveList: boolean;

  canWorkersCreateMilestone: boolean;
  canWorkersEditMilestone: boolean;
  canWorkersRemoveMilestone: boolean;

  canWorkersCreateEvent: boolean;
  canWorkersEditEvent: boolean;
  canWorkersRemoveEvent: boolean;

  canEditPersonalTimeSheet: boolean;
  canEditProjectPersonalTimeSheet: boolean;
  canEditManagerPersonalTimeSheet: boolean;
  canApprovePersonalTimeSheet: boolean;
  canApproveProjectPersonalTimeSheet: boolean;
  canApproveManagerPersonalTimeSheet: boolean;

  canUseOnlyOffice: boolean;
  canUseResourceUsageReport: boolean;

  conserveElementDuration: boolean;

  showTaskCompletionPercentage: boolean;

  allowDataScrapingForDebug: boolean;

  enterTimeAllocationInDays: boolean;

  enableSelfAssignment: boolean;

  lockBeforeIntegrationDate: boolean;

  syncAllocationDurationWithTask: boolean;

  warnOnDailyCriticalAmplitude: boolean;
  warnOnDailyCriticalVolume: boolean;
  warnOnInsufficientRestPeriod: boolean;
  warnOnUnavailability: boolean;
};

const planzoneSettings: PlanzoneSettings = {
  areWeeklyCalendarLockedForNonAdmin: false,
  areUsersNotifiedAfterAccountCreation: true,
  areProjectStatsHiddenInProjectListing: false,
  areTimeSheetsAutoIntegrated: true,
  canWorkersCreateTask: true,
  canWorkersEditTask: true,
  canWorkersRemoveTask: true,
  canWorkersCreateList: true,
  canWorkersEditList: true,
  canWorkersRemoveList: true,
  canWorkersCreateMilestone: true,
  canWorkersEditMilestone: true,
  canWorkersRemoveMilestone: true,
  canWorkersCreateEvent: true,
  canWorkersEditEvent: true,
  canWorkersRemoveEvent: true,
  canEditPersonalTimeSheet: true,
  canEditProjectPersonalTimeSheet: true,
  canEditManagerPersonalTimeSheet: true,
  canApprovePersonalTimeSheet: true,
  canApproveProjectPersonalTimeSheet: true,
  canApproveManagerPersonalTimeSheet: true,
  canUseOnlyOffice: false,
  canUseResourceUsageReport: true,
  conserveElementDuration: true,
  showTaskCompletionPercentage: true,
  allowDataScrapingForDebug: false,
  enterTimeAllocationInDays: false,
  enableSelfAssignment: false,
  lockBeforeIntegrationDate: false,
  syncAllocationDurationWithTask: false,
  warnOnDailyCriticalAmplitude: false,
  warnOnDailyCriticalVolume: false,
  warnOnInsufficientRestPeriod: false,
  warnOnUnavailability: false,
};

export type { PlanzoneSettings };

export { planzoneSettings };
